import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { Oval } from "react-loader-spinner";
import { Id, ToastPosition, TypeOptions, toast as _toast } from "react-toastify";
import shortid from "shortid";

import { ToastCheckIcon, ToastCloseIcon } from "../SvgIcon";
import { ToastWarningIcon } from "../SvgIcon";

export const toastStyles = {
  success: {
    style: {
      background: "#fff",
      border: "1px solid #fefefe",
      borderRadius: 3,
      color: "#333"
    },
    icon: () => <ToastCheckIcon />,
    closeButton: false
  },
  error: {
    style: {
      background: "#fff",
      border: "1px solid #fefefe",
      borderRadius: 3,
      color: "#333"
    },
    icon: () => <ToastCloseIcon />,
    closeButton: false
  },
  warning: {
    style: {
      background: "#fff",
      border: "1px solid #fefefe",
      borderRadius: 3,
      color: "#333"
    },
    icon: () => <ToastWarningIcon />,
    closeButton: false
  },
  info: {
    style: {
      background: "#fff",
      border: "1px solid #fefefe",
      borderRadius: 3,
      color: "#333"
    },
    icon: () => <ToastWarningIcon />,
    closeButton: false
  },
  default: {
    style: {
      padding: 0,
      boxShadow: "none",
      background: "transparent"
    },
    closeButton: false
  }
};

interface Props {
  message?: string;
  type: TypeOptions | "update" | "progress" | "progress_update" | "promise" | "promise_update" | "dismiss";
  position?: ToastPosition;
  toastId?: Id;
  progress?: number;
}

export const toast = ({ message, type, position = "bottom-center", toastId = shortid.generate(), progress }: Props) => {
  if (!message) {
    return null;
  }

  let props = {};

  const getToastProps = (newProps = {}) => {
    return {
      toastId,
      position,
      ...newProps
    };
  };
  switch (type) {
    case "success":
      props = getToastProps(toastStyles.success);
      break;
    case "error":
      props = getToastProps(toastStyles.error);
      break;
    case "warning":
      props = getToastProps(toastStyles.warning);
      break;
    case "info":
      props = getToastProps(toastStyles.info);
      break;
    default:
      props = getToastProps(toastStyles.default);
      break;
  }

  if (type === "dismiss") return _toast.dismiss(toastId);
  if (type === "update") return _toast(<div dangerouslySetInnerHTML={{ __html: message }} />, props);
  if (type === "progress" && progress !== undefined)
    return _toast(
      <div className="w-full flex bg-black rounded-md">
        <div className="w-1/5 flex justify-center items-center p-3.5">
          <CircularProgressbar
            minValue={0}
            maxValue={100}
            value={progress}
            strokeWidth={12}
            styles={buildStyles({
              pathColor: `#2F80ED`
            })}
          />
        </div>
        <div
          className="w-4/5 flex flex-col justify-center items-start text-gray-200 text-sm"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      </div>,
      props
    );
  if (type === "progress_update" && progress !== undefined)
    return _toast.update(toastId, {
      ...props,
      render: (
        <div className="w-full flex bg-black rounded-md">
          <div className="w-1/5 flex justify-center items-center p-3.5">
            {progress === 100 ? (
              <ToastCheckIcon />
            ) : (
              <CircularProgressbar
                minValue={0}
                maxValue={100}
                value={progress}
                strokeWidth={12}
                styles={buildStyles({
                  pathColor: `#2F80ED`
                })}
              />
            )}
          </div>
          <div
            className="w-4/5 flex flex-col justify-center items-start text-gray-200 text-sm"
            dangerouslySetInnerHTML={{ __html: message }}
          />
        </div>
      )
    });

  if (type === "promise")
    return _toast(
      <div className="w-full flex bg-black rounded-md">
        <div className="w-1/5 flex justify-center items-center p-3.5">
          <Oval width={17} height={17} />
        </div>
        <div
          className="w-4/5 flex flex-col justify-center items-start text-gray-200 text-sm"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      </div>,
      props
    );
  if (type === "promise_update")
    return _toast.update(toastId, {
      ...props,
      render: (
        <div className="w-full flex bg-black rounded-md">
          <div className="w-1/5 flex justify-center items-center p-3.5">
            <ToastCheckIcon />
          </div>
          <div
            className="w-4/5 flex flex-col justify-center items-start text-gray-200 text-sm"
            dangerouslySetInnerHTML={{ __html: message }}
          />
        </div>
      )
    });

  return _toast(<div dangerouslySetInnerHTML={{ __html: message }} />, props);
};
